module.exports = __webpack_public_path__ + "static/media/icon_calendar_green.a55d0ad3.svg";